import { render, staticRenderFns } from "./FormatsPage.vue?vue&type=template&id=74cb659a"
import script from "./FormatsPage.vue?vue&type=script&lang=js"
export * from "./FormatsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports